import { Controller } from "@hotwired/stimulus"

// Handles the task input form: clear after submit, maintain focus
export default class TaskInputController extends Controller {
  static targets = ["input"]

  reset() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
    }
  }
}
